import { render, staticRenderFns } from "./video-comp.vue?vue&type=template&id=674d2ccd&scoped=true&"
import script from "./video-comp.vue?vue&type=script&lang=js&"
export * from "./video-comp.vue?vue&type=script&lang=js&"
import style0 from "./video-comp.vue?vue&type=style&index=0&id=674d2ccd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674d2ccd",
  null
  
)

export default component.exports